var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-topbar",style:({ 'background': _vm.topbarColour() })},[_c('button',{staticClass:"p-link layout-menu-button",on:{"click":_vm.onMenuToggle}},[(!_vm.isDesktop())?_c('span',{staticClass:"pi pi-bars",class:_vm.textColor()}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }